import { render, staticRenderFns } from "./CpyDetail.vue?vue&type=template&id=6d5a8497&scoped=true"
import script from "./CpyDetail.vue?vue&type=script&lang=js"
export * from "./CpyDetail.vue?vue&type=script&lang=js"
import style0 from "./CpyDetail.vue?vue&type=style&index=0&id=6d5a8497&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a8497",
  null
  
)

export default component.exports